/** @format */

/**
 * Encode spaces in the path/query-safe way for img[src] (Azure blob names often include spaces).
 * Preserves existing query string (e.g. SAS) unchanged except spaces before `?` are in path only.
 */
export function encodeBannerPathSpaces(url: string): string {
  if (!url) return url;
  const q = url.indexOf('?');
  const path = q >= 0 ? url.slice(0, q) : url;
  const rest = q >= 0 ? url.slice(q) : '';
  if (!path.includes(' ')) return url;
  return path.replace(/ /g, '%20') + rest;
}

/** Read stored URL from API payload (camelCase or PascalCase). */
export function getCanonicalBannerUrlFromPayload(data: unknown): string {
  if (!data || typeof data !== 'object') return '';
  const o = data as Record<string, unknown>;
  return String(
    o.homeBannerImageUrl ?? o.HomeBannerImageUrl ?? ''
  ).trim();
}

/**
 * URL suitable for img[src]: prefer signed blob URL, else canonical.
 * Handles PascalCase API payloads and encodes spaces in the path.
 */
export function getBannerImgSrcFromPayload(data: unknown): string {
  const canonical = getCanonicalBannerUrlFromPayload(data);
  if (!data || typeof data !== 'object') {
    return encodeBannerPathSpaces(canonical);
  }
  const o = data as Record<string, unknown>;
  const signed = String(
    o.homeBannerSignedImageUrl ?? o.HomeBannerSignedImageUrl ?? ''
  ).trim();
  const pick = signed || canonical;
  return encodeBannerPathSpaces(pick);
}
